// Translations for Novi Hotel — IT (default), EN, DE

export const LANGUAGES = [
  { code: "it", label: "IT", name: "Italiano" },
  { code: "en", label: "EN", name: "English" },
];

const translations = {
  it: {
    nav: {
      camere: "Camere",
      servizi: "Servizi",
      ristorante: "Ristorante",
      contatti: "Contatti",
      prenota: "Prenota",
      openMenu: "Apri menu",
    },
    hero: {
      overline: "Novi Ligure · Alessandria · Piemonte",
      titleLine1: "Hotel a conduzione familiare",
      titleLine2: "",
      description:
        "Tredici camere semplici, ordinate, pulite. Un ambiente familiare per soggiornare e sentirti come a casa. Parcheggio privato, Ristorante, Wi-Fi, Aria condizionata. A pochi passi dal Museo dei Campionissimi e a 10 minuti di macchina dall'Outlet di Serravalle.",
      ctaRooms: "Scopri le camere",
      ctaContact: "Contattaci",
      scroll: "Scorri",
      imageAlt: "Novi Hotel esterno",
    },
    rooms: {
      overline: "Le Camere",
      titleLine1: "Tredici stanze,",
      titleLine2: "dimensioni diverse per esigenze diverse.",
      description:
        "Dall'ampia camera tripla, alla spaziosa doppia sino all'essenziale stanza singola. Disponiamo di camere di varie metrature per rispondere ad ogni esigenza!",
      labelRoom: "Camera",
      inquire: "Richiedi disponibilità",
      from: "da",
      currency: "€",
      guestsUnit: "ospiti",
      list: [
        {
          id: "deluxe",
          name: "Camere doppie",
          guests: "2 ospiti",
          description:
            "Letto King-Size o due letti singoli, bagni moderni, terrazzo privato. Spazio e comodità per due persone nelle nostre camere doppie.",
        },
        {
          id: "junior",
          name: "Camere singole",
          guests: "1 ospite",
          description:
            "L'essenziale per una persona: letto singolo, una scrivania, un armadio e un piccolo bagno moderno, pulito e ordinato.",
        },
        {
          id: "suite",
          name: "Camere triple",
          guests: "2–4 ospiti",
          description:
            "La nostra soluzione più ampia: tre letti singoli e un comodo bagno per rendere il vostro soggiorno confortevole.",
        },
      ],
    },
    services: {
      overline: "Servizi",
      titleLine1: "Piccoli gesti,",
      titleLine2: "grande attenzione.",
      description:
        "Abbiamo scelto di fare poche cose, fatte con cura. L'ospitalità piemontese non ha bisogno di eccessi: bastano materie prime vere, tempi giusti e una genuina voglia di far sentire a casa.",
      restaurantLabel: "Ristorante Novi",
      restaurantNote: "aperto anche ai non alloggiati",
      ambianceAlt: "Vino e cucina piemontese",
      list: [
        {
          id: "ristorante",
          title: "Ristorante & Enoteca",
          description:
            "Cucina piemontese contemporanea. Tajarin, brasato al Barolo e una carta dei vini con oltre 200 etichette locali.",
        },
        {
          id: "colazione",
          title: "Colazione d'autore",
          description:
            "Prodotti di piccoli artigiani del territorio: pane lievito madre, miele di acacia, brioche appena sfornate.",
        },
        {
          id: "parcheggio",
          title: "Parcheggio privato",
          description:
            "Parcheggio coperto gratuito per gli ospiti, direttamente all'interno della proprietà.",
        },
        {
          id: "wifi",
          title: "Wi-Fi in fibra",
          description:
            "Connessione veloce e stabile in tutte le camere e negli spazi comuni. Ideale anche per lo smart working.",
        },
        {
          id: "bici",
          title: "Bici e itinerari",
          description:
            "Biciclette a disposizione per esplorare le colline del Gavi, Novi e del Monferrato. Mappe e percorsi consigliati.",
        },
        {
          id: "giardino",
          title: "Giardino & Relax",
          description:
            "Un giardino interno con ulivi e lavanda. Uno spazio per leggere, pensare o semplicemente non fare nulla.",
        },
      ],
    },
    contact: {
      overline: "Contatti",
      titleLine1: "Scrivici,",
      titleLine2: "saremo felici di accoglierti.",
      description:
        "Per richieste di disponibilità, prezzi ed ulteriori informazioni, compila il modulo o contattaci direttamente.",
      labels: {
        address: "Indirizzo",
        phone: "Telefono",
        email: "Email",
        reception: "Reception",
      },
      receptionLines: ["Aperta 7 giorni su 7", "07:00 — 23:00"],
      addressLines: [
        "Novi Hotel",
        "Via Ovada 115",
        "15067 Novi Ligure (AL) — Italia",
      ],
      form: {
        name: "Nome e cognome *",
        email: "Email *",
        phone: "Telefono",
        message: "Messaggio *",
        messagePlaceholder:
          "Raccontaci la tua richiesta, date, numero di ospiti…",
        submit: "Invia messaggio",
        submitting: "Invio in corso…",
        privacy:
          "Inviando il modulo accetti il trattamento dei dati ai soli fini della risposta alla tua richiesta.",
      },
      toasts: {
        validation:
          "Compila i campi obbligatori: nome, email e messaggio.",
        success:
          "Grazie! Abbiamo ricevuto il tuo messaggio, ti risponderemo al più presto.",
        error:
          "Qualcosa è andato storto. Riprova o chiamaci al telefono.",
        genericError: "Errore di invio.",
      },
    },
    footer: {
      tagline:
        "Un piccolo hotel a conduzione familiare a Novi Ligure, a pochi passi dal Museo dei Campionissimi e a 10 minuti di macchina dall'Outlet di Serravalle.",
      contactsLabel: "Contatti",
      hoursLabel: "Orari",
      hours: [
        "Reception 07:00 — 23:00",
        "Ristorante 12:30 — 14:30",
        "19:30 — 22:30",
      ],
      rights: "Tutti i diritti riservati.",
      vat: "P.IVA 02622700066 · Novi Ligure, Italia",
    },
    langSwitcher: {
      label: "Lingua",
    },
    gallery: {
      overline: "Galleria",
      titleLine1: "Uno sguardo nella nostra struttura.",
      titleLine2: "",
      description: "",
    },
    restaurant: {
      overline: "Ristorante",
      titleLine1: "Antica Trattoria",
      titleLine2: "dell'Angelo.",
      intro:
        "Al piano terra dell'hotel. Dal 1936, una trattoria con piatti tipici tradizionali dove riscoprire i sapori di una volta e sentirsi come a casa.",
      description:
        "Un menù vario che cambia tutti i giorni e vi verrà raccontato a voce in sala, con diversi primi, secondi, contorni e dolci fatti in casa tra cui scegliere.",
      label: "Antica Trattoria dell'Angelo",
      note: "aperta anche ai non alloggiati",
      imageAlt: "Atmosfera del ristorante",
      specialtiesLabel: "Le nostre specialità",
      specialties: [
        "Panissa fritta e lardo",
        "Vitello tonnato",
        "Agnolotti piemontesi",
        "Rabatòn",
        "Trippa con patate e fagioli",
        "e molto altro ancora…",
      ],
      hoursLabel: "Orari cucina",
      hours: ["Pranzo  12:00 — 14:00", "Cena  19:00 — 21:30", "Chiuso la domenica"],
      reservationLabel: "Prenotazioni",
      reservationText: "Per prenotazioni, chiamateci al",
    },
  },

  en: {
    nav: {
      camere: "Rooms",
      servizi: "Services",
      ristorante: "Restaurant",
      contatti: "Contact",
      prenota: "Book",
      openMenu: "Open menu",
    },
    hero: {
      overline: "Novi Ligure · Alessandria · Piedmont",
      titleLine1: "A family-run hotel",
      titleLine2: "",
      description:
        "Thirteen simple, neat, well-kept rooms. A welcoming family atmosphere where you stay and feel at home. Private parking, Restaurant, Wi-Fi, Air conditioning. Just a short walk from the Museo dei Campionissimi and a 10-minute drive from the Serravalle Designer Outlet.",
      ctaRooms: "Discover the rooms",
      ctaContact: "Get in touch",
      scroll: "Scroll",
      imageAlt: "Novi Hotel exterior",
    },
    rooms: {
      overline: "The Rooms",
      titleLine1: "Thirteen rooms,",
      titleLine2: "different sizes for different needs.",
      description:
        "From the spacious triple room, to the comfortable double, all the way to the essential single. We offer rooms of various sizes to meet every need!",
      labelRoom: "Room",
      inquire: "Check availability",
      from: "from",
      currency: "€",
      guestsUnit: "guests",
      list: [
        {
          id: "deluxe",
          name: "Double rooms",
          guests: "2 guests",
          description:
            "King-size bed or two single beds, modern bathrooms, private terrace. Space and comfort for two people in our double rooms.",
        },
        {
          id: "junior",
          name: "Single rooms",
          guests: "1 guest",
          description:
            "The essentials for one person: a single bed, a desk, a wardrobe and a small modern bathroom, clean and tidy.",
        },
        {
          id: "suite",
          name: "Triple rooms",
          guests: "2–4 guests",
          description:
            "Our most spacious option: three single beds and a comfortable bathroom to make your stay enjoyable.",
        },
      ],
    },
    services: {
      overline: "Services",
      titleLine1: "Small gestures,",
      titleLine2: "great attention.",
      description:
        "We have chosen to do a few things, well. Piedmontese hospitality needs no excess: just real ingredients, the right time and a genuine wish to make you feel at home.",
      restaurantLabel: "Restaurant Novi",
      restaurantNote: "open also to non-resident guests",
      ambianceAlt: "Wine and Piedmontese cuisine",
      list: [
        {
          id: "ristorante",
          title: "Restaurant & Wine cellar",
          description:
            "Contemporary Piedmontese cuisine. Tajarin, Barolo-braised beef and a wine list with over 200 local labels.",
        },
        {
          id: "colazione",
          title: "Signature breakfast",
          description:
            "Products from small local artisans: sourdough bread, acacia honey, freshly baked brioche.",
        },
        {
          id: "parcheggio",
          title: "Private parking",
          description:
            "Free covered parking for our guests, right inside the property.",
        },
        {
          id: "wifi",
          title: "Fibre Wi-Fi",
          description:
            "Fast and stable connection in all rooms and common areas. Perfect also for remote work.",
        },
        {
          id: "bici",
          title: "Bikes and itineraries",
          description:
            "Bicycles available to explore the hills of Gavi, Novi and Monferrato. Suggested maps and routes.",
        },
        {
          id: "giardino",
          title: "Garden & Relax",
          description:
            "An inner garden with olive trees and lavender. A space to read, think or simply do nothing.",
        },
      ],
    },
    contact: {
      overline: "Contact",
      titleLine1: "Write to us,",
      titleLine2: "we'll be glad to host you.",
      description:
        "For availability requests, prices and further information, fill in the form or contact us directly.",
      labels: {
        address: "Address",
        phone: "Phone",
        email: "Email",
        reception: "Reception",
      },
      receptionLines: ["Open 7 days a week", "07:00 — 23:00"],
      addressLines: [
        "Novi Hotel",
        "Via Ovada 115",
        "15067 Novi Ligure (AL) — Italy",
      ],
      form: {
        name: "Full name *",
        email: "Email *",
        phone: "Phone",
        message: "Message *",
        messagePlaceholder:
          "Tell us your request, dates, number of guests…",
        submit: "Send message",
        submitting: "Sending…",
        privacy:
          "By submitting the form you agree to the processing of your data solely to reply to your request.",
      },
      toasts: {
        validation:
          "Please fill in the required fields: name, email and message.",
        success:
          "Thank you! We've received your message and will get back to you soon.",
        error:
          "Something went wrong. Please try again or call us by phone.",
        genericError: "Submission error.",
      },
    },
    footer: {
      tagline:
        "A small family-run hotel in Novi Ligure, just a short walk from the Museo dei Campionissimi and a 10-minute drive from the Serravalle Designer Outlet.",
      contactsLabel: "Contact",
      hoursLabel: "Hours",
      hours: [
        "Reception 07:00 — 23:00",
        "Restaurant 12:30 — 14:30",
        "19:30 — 22:30",
      ],
      rights: "All rights reserved.",
      vat: "VAT 02622700066 · Novi Ligure, Italy",
    },
    langSwitcher: {
      label: "Language",
    },
    gallery: {
      overline: "Gallery",
      titleLine1: "A glimpse inside our hotel.",
      titleLine2: "",
      description: "",
    },
    restaurant: {
      overline: "Restaurant",
      titleLine1: "Antica Trattoria",
      titleLine2: "dell'Angelo.",
      intro:
        "On the ground floor of the hotel. Since 1936, a trattoria serving traditional dishes where you can rediscover the flavours of yesteryear and feel right at home.",
      description:
        "A varied menu that changes every day and is presented to you at the table — with several first courses, mains, sides and home-made desserts to choose from.",
      label: "Antica Trattoria dell'Angelo",
      note: "open to non-resident guests too",
      imageAlt: "Restaurant atmosphere",
      specialtiesLabel: "Our specialties",
      specialties: [
        "Fried panissa with lardo",
        "Vitello tonnato",
        "Piedmontese agnolotti",
        "Rabatòn (regional dumplings)",
        "Tripe with potatoes and beans",
        "And much more…",
      ],
      hoursLabel: "Kitchen hours",
      hours: ["Lunch  12:00 — 14:00", "Dinner  19:00 — 21:30", "Closed on Sundays"],
      reservationLabel: "Reservations",
      reservationText: "For bookings, please call us at",
    },
  },
};

export default translations;
